"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageScaleStrategy;
(function (ImageScaleStrategy) {
    ImageScaleStrategy["FILL"] = "FILL";
    ImageScaleStrategy["FIT"] = "FIT";
})(ImageScaleStrategy = exports.ImageScaleStrategy || (exports.ImageScaleStrategy = {}));
var TemplatePropertyType;
(function (TemplatePropertyType) {
    TemplatePropertyType["Text"] = "txt";
    TemplatePropertyType["Media"] = "media";
    TemplatePropertyType["Logo"] = "logo";
    TemplatePropertyType["Palette"] = "plt";
    TemplatePropertyType["Color"] = "clr";
    TemplatePropertyType["Number"] = "num";
    TemplatePropertyType["Slider"] = "sld";
    TemplatePropertyType["Checkbox"] = "chk";
    TemplatePropertyType["DropDown"] = "drp";
    TemplatePropertyType["Virtual"] = "vrt";
})(TemplatePropertyType = exports.TemplatePropertyType || (exports.TemplatePropertyType = {}));
//# sourceMappingURL=TemplateManifest.js.map